import ContactForm from '@/components/ContactForm'
import EntryHeader from '@/components/EntryHeader'
import FlexibleContent from '@/components/FlexibleContent'
import Main from '@/components/Main'
import SEO from '@/components/SEO'
import { FeaturedImageFragment } from '@/fragments/FeaturedImage'
import { FlexibleContentFragment } from '@/fragments/FlexibleContent'
import { GravityFormsFragment } from '@/fragments/GravityForms'
import { PostsFragment } from '@/fragments/Posts'
import styles from '@/styles/pages/_citgo.module.scss'
import { gql } from '@apollo/client'

export default function PageCitgo(props) {
  // Loading state for previews
  if (props.loading) {
    return null
  }

  const metaDesc = props?.data?.page?.seo?.metaDesc
  const { title, featuredImage } = props?.data?.page ?? { title: '' }
  const flexibleContent = props?.data?.page?.template?.flexibleContent?.flexibleContentFields ?? []
  const gravityforms = props?.data?.gfForms?.nodes || []
  const form = gravityforms.find((node) => node.databaseId === 1)
  const headerForm = gravityforms.find((node) => node.databaseId === 2)
  const seoTitle = props?.data?.page?.seo?.title

  return (
    <>
      <SEO title={seoTitle || title} description={metaDesc} imageUrl={featuredImage?.node?.sourceUrl} />

      <div className={styles.citgoHeading}>
        <EntryHeader
          pageFields={props?.data?.page}
          image={featuredImage?.node}
          form={headerForm}
          title={title}
          highlightWords={['design', 'develop', 'deliver']}
        />
      </div>

      <Main>
        <FlexibleContent content={flexibleContent} />
      </Main>

      {form && <ContactForm form={form} />}
    </>
  )
}

PageCitgo.variables = ({ databaseId }, ctx) => {
  return {
    databaseId,
    asPreview: ctx?.asPreview
  }
}

PageCitgo.hideNavigation = true

PageCitgo.query = gql`
  ${FeaturedImageFragment}
  ${FlexibleContentFragment}
  ${GravityFormsFragment}
  ${PostsFragment}
  query GetPageData($databaseId: ID!, $asPreview: Boolean = false) {
    page(id: $databaseId, idType: DATABASE_ID, asPreview: $asPreview) {
      title
      content
      seo {
        metaDesc
        title
      }
      ...FeaturedImageFragment
      ...FlexibleContentFragment
      innerHeroFields {
        content
        eyebrowText
        fieldGroupName
        includeForm
        title
        heroLink {
          url
          title
          target
        }
      }
    }
    posts(first: 12) {
      nodes {
        ...PostsFeedItemFragment
      }
    }
    gfForms {
      nodes {
        ...GravityFormsFragment
      }
    }
  }
`
